import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=ee07eec0&scoped=true&"
import script from "./CategorySlider.vue?vue&type=script&lang=js&"
export * from "./CategorySlider.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&id=ee07eec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee07eec0",
  null
  
)

export default component.exports